import { Routes, Route } from "react-router-dom";
import TajweedRuleList from "./list";
import TajweedRuleForm from "./form";
import ContributorAnnotationList from "./list";
import ContributorAnnotationForm from "./form";

function ContributorAnnotationPage() {
	return (
		<Routes>
			<Route path="/" element={<ContributorAnnotationList />} />
			<Route path="/add" element={<ContributorAnnotationForm />} />
			<Route path="/:c/:v" element={<ContributorAnnotationForm />} />
		</Routes>
	);
}

export default ContributorAnnotationPage;
